/**
 * The searchselect (kx-multiselect-dropdown) setup shared by Agent Studio and the guided
 * agent wizard.
 */

/** A fixed option list: the dropdown lists `possible_value`, never a bare array. */
export interface SelectOptions {
    possible_value: Array<{ id: string; text: string }>;
}

export function optionsOf(items: Array<{ id: string; text: string }>): SelectOptions {
    return { possible_value: items };
}

/**
 * A searchselect's question for a fixed {id, text} list, kept in the given order. Each
 * dropdown needs its own: the component writes its options into it.
 */
export function listQuestion(key: string): Record<string, any> {
    return { key, getterKey: 'id', getterValue: 'text', stopSorting: true };
}

/** One choice, searched in the open list; no advanced-search dialog or voice input. */
export const SINGLE_SELECT = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    allowSearchFilter: true,
    advancesearch: false,
    speechToText: false,
};

/**
 * A list searched on the server as the user types (GET_PAGE with search / search_columns),
 * a page at a time; the first page loads at once.
 */
export const SERVER_SEARCH_SELECT = { ...SINGLE_SELECT, apliCall: true, custom: true };
